// Simple singleton registry for allDropdowns

let allDropdowns: Record<string, Array<any>> | undefined;

export function setAllDropdowns(next: Record<string, Array<any>> | undefined) {
  allDropdowns = next;
}

export function getAllDropdowns(): Record<string, Array<any>> | undefined {
  return allDropdowns;
}